module.exports = __webpack_public_path__ + "img/code.d6178855.png";